import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import NotifStatusIcon from "../../../../media/images/icons/notif-status";
import ButtonTabbar from "../../../components/ButtonTabbar";
import MessagesAndNotifs from "./MessagesAndNotifs";
import AccessPrivacy from "./AccessPrivacy";

export default function SettingsPage() {
  const theme = useTheme();

  const [tabbuttons] = useState([
    {
      title: "تنظیم پیام‌ها و اطلاع‌رسانی",
    },
    {
      title: "تنظیم دسترسی‌ها",
    },
  ]);

  const [tabIndex, setTabIndex] = useState(0);

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 600,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            تنظیمات{" "}
          </Typography>
        }
      />
      <Box
        sx={{
          flex: "1",
          overflowY: "auto",
          paddingX: "8px",
          paddingY: "8px",
        }}
      >
        <Box
          sx={{
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            padding: "8px 0px",
          }}
        >
          <NotifStatusIcon size={26} color={theme.palette.primary.main} />
          <Typography
            sx={{
              fontSize: "18px",
              color: "primary.main",
              fontWeight: "600",
            }}
          >
            تنظیم اطلاع‌رسانی و دسترسی{" "}
          </Typography>
        </Box>
        <ButtonTabbar
          activeIndex={tabIndex}
          handleChangeTab={(index) => setTabIndex(index)}
          buttons={tabbuttons}
        />

        {getTabContent(tabIndex)}
      </Box>
    </>
  );
}

function getTabContent(index: number) {
  switch (index) {
    case 0:
      return <MessagesAndNotifs />;

    case 1:
      return <AccessPrivacy />;
  }
}
